import { useWindowSize } from '@vueuse/core';
import { computed, readonly } from 'vue';

const SCREEN_CONFIG = {
  desktopBreakpoint: 767 
};

export const useScreenSize = () => {
  const { width } = useWindowSize();

  const isDesktop = computed(() => width.value > SCREEN_CONFIG.desktopBreakpoint);
  
  return {
    isDesktop: readonly(isDesktop)
  };
}; 
